import React, { useEffect, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./QRLContent.css";
import {
    Box,
    Typography,
    Button,
} from "@mui/material";

const heroSlides = [
    {
        id: 1,
        image: `${process.env.PUBLIC_URL}/Assets/QRL/qrlBanner.png`,
        title: "AI Era is reshaping every engineering role",
        description:
            "Ignite adapts learning journeys and curated Learning Hubs to your role, interests, and progress making learning intuitive, relevant, and engaging.",
        highlights: [
            "Technology roles are evolving",
            "Client demands are changing",
            "Full stack mastery is non negotiable",
        ],
    },
];

const QRLContent = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    

    useEffect(() => {
        if (heroSlides.length <= 1) return undefined;

        const intervalId = window.setInterval(() => {
            setActiveSlide((currentSlide) =>
                currentSlide === heroSlides.length - 1 ? 0 : currentSlide + 1
            );
        }, 6000);

        return () => window.clearInterval(intervalId);
    }, []);

    const currentSlide = heroSlides[activeSlide];

    const handleExplore = () => {
        const learningSection = document.getElementById(
            "quantum-reinvent-learning-section"
        );

        learningSection?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    return (
        <Box component="main" className="quantum-reinvent-page">
            {/* HERO SECTION */}
            <Box
                component="section"
                className="quantum-hero"
                sx={{
                    backgroundImage: `
            linear-gradient(
              90deg,
              rgba(13, 12, 17, 0.96) 0%,
              rgba(13, 12, 17, 0.80) 40%,
              rgba(13, 12, 17, 0.15) 60%,
              rgba(13, 12, 17, 0.05) 100%
            ),
            url("${currentSlide.image}")
          `,
                }}
            >
                <Box className="quantum-hero-content">
                    <Typography
                        variant="h1"
                        className="hero-quote"
                        fontFamily="Graphik-Bold"
                        fontSize="1.7rem"
                        marginBottom="1.2rem"
                        fontWeight="700"
                    >
                        {currentSlide.title}
                    </Typography>

                    <Typography
                        component="p"
                        className="quantum-hero-description"
                        fontFamily="Graphik-Regular"
                    >
                        {currentSlide.description}
                    </Typography>

                    <Box className="quantum-hero-highlights">
                        {currentSlide.highlights.map((highlight) => (
                            <Box className="quantum-highlight-card" key={highlight}>
                                <Typography
                                    component="p"
                                    fontFamily="Graphik-Regular"
                                    className="quantum-highlight-text"
                                >
                                    {highlight}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* Slider dots */}
                {heroSlides.length > 1 && (
                    <Box className="quantum-slider-dots">
                        {heroSlides.map((slide, index) => (
                            <button
                                key={slide.id}
                                type="button"
                                className={`quantum-slider-dot ${index === activeSlide ? "quantum-slider-dot-active" : ""
                                    }`}
                                onClick={() => setActiveSlide(index)}
                                aria-label={`Open hero slide ${index + 1}`}
                            />
                        ))}
                    </Box>
                )}
            </Box>

            {/* ANNOUNCEMENT SECTION
            <Box className="hero-info-strip">
                <img src="Assets/info-icon.svg" alt="info" />
                <Box className="scroll-wrapper">
                    <Typography fontFamily="Graphik" className="ui-typo scroll-text">
                        "Exciting Session on 9th Jan. Please Enroll for this session
                        before the link expires."
                    </Typography>
                </Box>
            </Box> */}

            {/* LEARNING SECTION */}
            <Box
                component="section"
                id="quantum-reinvent-learning-section"
                className="quantum-learning-section"
            >
                <Typography
                    variant="h1"
                    className="quantum-learning-title"
                    fontFamily="Graphik-Semibold"
                    fontSize="1.7rem"
                    marginBottom="1.2rem"
                    fontWeight="700"
                >
                    Quantum Reinvent Learning
                </Typography>

                <Typography
                    component="p"
                    fontFamily="Graphik-Regular"
                    className="quantum-learning-description"
                >
                    We are in a new era where AI is transforming the way we work,
                    deliver, sell, and innovate. The roles and skills needed to succeed
                    in this new world are evolving rapidly.
                </Typography>

                <Button
                    type="button"
                    variant="contained"
                    className="quantum-explore-button"
                    onClick={() =>
                        window.open(
                            "https://lnttportal.atci.accenture.com/QuantumReinventLateral/",
                            "_blank"
                        )
                    }
                    startIcon={<ArrowForwardIcon />}
                    disableElevation
                >
                    <div>Click here to Explore</div>
                </Button>
            </Box>
        </Box>
    );
};

export default QRLContent;